import { styled } from '@mui/material';

import { I18nResources, useI18n } from '@app-velocity/i18n';
import { Typography } from '@app-velocity/ui';

const StyledTitle = styled(Typography)({
  fontSize: 20,
  lineHeight: 1.3,
  fontWeight: 600,
  textAlign: 'center',
});

export type TitleProps = {
  title: I18nResources;
};

export const Title = ({ title }: TitleProps) => {
  const { t } = useI18n();

  return <StyledTitle component="h2">{t(title)}</StyledTitle>;
};
